// OpenAI API key loaded from environment variable
export const OPENAI_API_KEY = process.env.REACT_APP_OPENAI_API_KEY;

export const API_URLS = {
  OPENAI: "https://api.openai.com/v1/chat/completions",
  OVERPASS: "https://overpass-api.de/api/interpreter",
  OPENEPI_SOIL: "https://api.openepi.io/soil/property",
  NASA_POWER: "https://power.larc.nasa.gov/api/temporal/daily/point",
};

export const MAP_CONFIG = {
  DEFAULT_CENTER: [9.5916, 76.5222],
  DEFAULT_ZOOM: 13,
  OSM_TILE_URL:
    "https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png",
  SATELLITE_TILE_URL:
    "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
  LABELS_TILE_URL:
    "https://server.arcgisonline.com/ArcGIS/rest/services/Reference/World_Boundaries_and_Places/MapServer/tile/{z}/{y}/{x}",
};
